import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { liquidation_maturity_form_keys } from './liquidation-maturity.constants';
import { Subject } from 'rxjs';
import { IIbanObject } from 'src/app/modules/athora/athora.constants';

@Component({
  selector: 'app-liquidation-maturity',
  templateUrl: './liquidation-maturity.component.html',
  styleUrl: './liquidation-maturity.component.scss'
})
export class LiquidationMaturityComponent implements OnChanges, OnDestroy {

  @Input() form: FormGroup;
  @Input() ibanList: IIbanObject[];

  formKeys = CommonUtils.assign(liquidation_maturity_form_keys);

  destroy$ = new Subject();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ibanList'] && changes['ibanList'].currentValue) {
      this.populateIbanOptions();
    }
  }

  populateIbanOptions(): void {
    this.formKeys = CommonUtils.populateIbanOptions(this.formKeys, this.ibanList);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
